/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExcelAnalysisVo } from './ExcelAnalysisVo';
import {
    ExcelAnalysisVoFromJSON,
    ExcelAnalysisVoFromJSONTyped,
    ExcelAnalysisVoToJSON,
    ExcelAnalysisVoToJSONTyped,
} from './ExcelAnalysisVo';

/**
 * 
 * @export
 * @interface ResponseExcelAnalysisVo
 */
export interface ResponseExcelAnalysisVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseExcelAnalysisVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseExcelAnalysisVo
     */
    message?: string;
    /**
     * 
     * @type {ExcelAnalysisVo}
     * @memberof ResponseExcelAnalysisVo
     */
    data?: ExcelAnalysisVo;
}

/**
 * Check if a given object implements the ResponseExcelAnalysisVo interface.
 */
export function instanceOfResponseExcelAnalysisVo(value: object): value is ResponseExcelAnalysisVo {
    return true;
}

export function ResponseExcelAnalysisVoFromJSON(json: any): ResponseExcelAnalysisVo {
    return ResponseExcelAnalysisVoFromJSONTyped(json, false);
}

export function ResponseExcelAnalysisVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseExcelAnalysisVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ExcelAnalysisVoFromJSON(json['data']),
    };
}

export function ResponseExcelAnalysisVoToJSON(json: any): ResponseExcelAnalysisVo {
    return ResponseExcelAnalysisVoToJSONTyped(json, false);
}

export function ResponseExcelAnalysisVoToJSONTyped(value?: ResponseExcelAnalysisVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': ExcelAnalysisVoToJSON(value['data']),
    };
}

